import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Geometry, Coordinates, CoordinateType, Bounds } from '../shared/geo/ovs.geocoding';
import { OvsComponent } from '../shared/core/ovs.core';
import { ResortDetail } from '../models/presentation.model';
import { ResortComponent } from '../shared/resort.component';

@Component({
  selector: 'resort-destination',
  templateUrl: './resort-destination.component.html',
  styleUrls: ['./resort-destination.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResortDestinationComponent extends ResortComponent 
{
    @Input()
    public resort: ResortDetail;
    @Input()
    public title: string;
    @Input()
    public mapGeometry: Geometry;

    protected initialize(): void
    {
        this.listenForChange(() => this.resort, (o, n) => this.onResortChanged(n));
    }

    private onResortChanged(resort: ResortDetail): void
    {
        if (!resort)
        {
            this.mapGeometry = null;
            return;
        }

        let geo: Geometry = new Geometry();
        geo.Coordinates = new Coordinates(resort.latitude, resort.longitude, CoordinateType.Center);
        this.mapGeometry = geo;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/resort-destination.component.ts